import { render, staticRenderFns } from "./SelectClassificationType.vue?vue&type=template&id=52ccd295"
import script from "./SelectClassificationType.vue?vue&type=script&lang=js"
export * from "./SelectClassificationType.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports